export const ACCESSIBILITY = 'ACCESSIBILITY';
export const BILLING = 'BILLING';
export const CANCEL_SERVICE = 'CANCEL_SERVICE';
export const CONSENT = 'CONSENT';
export const CONTACT_CDV = 'CONTACT_CDV';
export const CONTACT_HSD = 'CONTACT_HSD';
export const CONTACT_OTHER = 'CONTACT_OTHER';
export const CONTACT_VID = 'CONTACT_VID';
export const CONTACT_XH = 'CONTACT_XH';
export const DEVICE_SWAP_INTERNET = 'DEVICE_SWAP_INTERNET';
export const DEVICE_SWAP_REWARDS = 'DEVICE_SWAP_REWARDS';
export const DEVICE_SWAP_VIDEO_COMBO = 'DEVICE_SWAP_VIDEO_COMBO';
export const MODIFY_SERVICE = 'MODIFY_SERVICE';
export const NPS_FALLOUT_CDV = 'NPS_FALLOUT_CDV';
export const NPS_FALLOUT_VID_HSD_X1 = 'NPS_FALLOUT_VID_HSD_X1';
export const NPS_FALLOUT_XH = 'NPS_FALLOUT_XH';
export const OOFOOTPRINT = 'OOFOOTPRINT';
export const PROACTIVE_REPAIR_INGRESS = 'PROACTIVE_REPAIR_INGRESS';
export const RETENTION = 'RETENTION';
export const RETENTION_HSD_IE = 'RETENTION_HSD_IE';
export const TROUBLESHOOT_CDV = 'TROUBLESHOOT_CDV';
export const TROUBLESHOOT_HSD = 'TROUBLESHOOT_HSD';
export const TROUBLESHOOT_VID = 'TROUBLESHOOT_VID';
export const WEAREONIT = 'WEAREONIT';

export const unavailableIntents = [BILLING, CONTACT_CDV, CONTACT_HSD, CONTACT_VID, CONTACT_XH];
